import { wrapAsyncFn } from "@faire/web--source/common/wrapAsyncFn";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useCategoryPageFilterKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useRequestReferrer } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { createCategoryPageFiltersQueryKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/__internal__/createCategoryPageFiltersQueryKeys";
import { fetchFiltersResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/__internal__/fetchFiltersResults";
import { recordPerformanceMark } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/recordPerformanceMark";
import { useIsCategoryPageFilterSplitEnabled } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageFilterSplitEnabled";
import {
  FILTERS_TIMING_FETCH_END_KEY,
  FILTERS_TIMING_FETCH_START_KEY,
} from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/consts";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";

export const useCategoryPageSplitFilterQuery = () => {
  const filterKeys = useCategoryPageFilterKeys();
  const requestReferrer = useRequestReferrer();
  const navigationPath = useCurrentNavigationPath();
  const isFilterSplitEnabled = useIsCategoryPageFilterSplitEnabled();

  return useQuery({
    queryKey: createCategoryPageFiltersQueryKeys({
      navigationPath,
      filterKeys,
      requestReferrer,
    }),
    queryFn: async ({ signal }) =>
      wrapAsyncFn(
        () =>
          fetchFiltersResults(
            {
              navigationPath,
              filterKeys,
              requestReferrer,
            },
            { signal }
          ),
        {
          before: () => recordPerformanceMark(FILTERS_TIMING_FETCH_START_KEY),
          after: () => recordPerformanceMark(FILTERS_TIMING_FETCH_END_KEY),
        }
      ),
    enabled: isFilterSplitEnabled,
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
